<template>
    <div id="addAccordionModal">
        <button @click="showModal" class="openModalButton" :disabled="!isActive">
            <i v-if="!isEdit" class="fa-circle-plus fas fa-2xl"></i>
            <i v-if="isEdit" class="fa-pen-to-square fas fa-2xl"></i>
        </button>
        <button v-if="isEdit" @click="removeAccordion" class="removeAccordionButton"
            :style="showDelete ? '' : 'display:none;'" :disabled="!isActive">
            <i class="fa-trash-can fas fa-2xl"></i>
        </button>
        <div v-if="modalActive" class="modal" @click.self="hideModal">
            <div class="modalForm">
                <h2 class="modalTitle">Add Accordion</h2>
                <div class="searchContainer">
                    <div class="formRow"><span class="inputTitle">Search Name: </span><input type="text" v-model="searchText" /></div>
                </div>
                <hr />
                <ListingTable v-if="accordions" :columns="columns" :filterCriteria="filterCriteria" :actions="actionMappings" 
                    :key="componentKey" :intitializationParameters="{ sortBy: 'id', sortDirection: 'desc', pageSize: '10'}" />
                <div class="formRow">
                    <button @click="hideModal" class="cancelButton">Cancel</button>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import {data} from '../../shared/data';
import ListingTable from '@/components/shared/ListingTable.vue';

export default {
    name: 'AddAccordionModal',
    components: { ListingTable },
    props: {
        isActive: Boolean,
        onAccordionSave: Function,
        accordionCode: String,
        showDelete: {
            type: Boolean,
            default: true
        }
    },
    data: function() {
        return {
            modalActive: false,
            accordionCode_local: '',
            searchText: '',
            accordions: [],
            componentKey: 0,
            columns: [ 
                {
                    headerDisplayName: "ID",
                    width: "10%",
                    fieldName: "id"
                },
                {
                    headerDisplayName: "Name",
                    width: "50%",
                    fieldName: "name",
                    isEditLink: true
                },
                {
                    headerDisplayName: "Code",
                    width: "40%",
                    fieldName: "code"
                }
            ],
            actionMappings: {
                onSelect: this.saveAccordion,
                onLoadData: this.getAccordions
            },

        }
    },
    computed: {
        filterCriteria () {
            var criteria = [];
            if(this.searchText != "") 
                criteria.push( {
                    dataType: "String",
                    fieldName: "name",
                    value: this.searchText
                });
            return criteria;
        },
        isEdit() {
            return this.accordionCode != null && this.accordionCode != '';
        }
    },
    updated() {
        this.accordionCode_local = this.accordionCode;
    },
    watch: {
        accordionCode: function() {
            this.accordionCode_local = this.accordionCode;

        }
    },
    mounted() {
        document.addEventListener("keydown", (e) => {
            if(!this.modalActive) return;
            if (e.key == 'Escape')
                this.hideModal();
        });
    },
    methods: {
        showModal: async function() {
            this.accordions = await this.getAccordions();
            this.modalActive = true;
        },
        hideModal: function() {
            this.modalActive = false;
            this.searchText = '';
        },
        getAccordions: async function() {
            return await data.getAllAccordions(this.searchText, false);
        },
        saveAccordion: async function(acc) {
            this.accordionCode_local = acc.code;
            if(this.onAccordionSave) 
                this.onAccordionSave(this.accordionCode_local, this.accordions.find(search => search.code === acc.code));
            this.hideModal();
        },
        removeAccordion: async function() {
            this.accordionCode_local = null;
            if(this.onAccordionSave)
                this.onAccordionSave(this.accordionCode_local);
        }
    }

}
</script>

<style scoped>
    .modal {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0px;
        left: 0px;
        backdrop-filter: blur(4px);
        padding: 100px 0 0 0;
        display: flex;
        justify-content: center;
        z-index: 10;
    }
    .modalForm {
        position: relative;
        border: 1px solid lightgray;
        background-color: white;
        width: 800px;
        padding: 20px;
        text-align: left;
        max-height: calc(100vh - 210px);
        overflow-y: auto;
        overflow-x: hidden;
        z-index: 20;
    }
    .modalTitle {
        width: 100%;
        text-align: center;
    }
    #addAccordionModal {
        display: inline-block;
    }
    .openModalButton {
        display: inline-block;
        background-color: unset;
        border: none;
        cursor: pointer;
        font-size: 12px;
        color:#036991;
    }
    .removeAccordionButton {
        display: inline-block;
        background-color: unset;
        border: none;
        cursor: pointer;
        font-size: 12px;
        color:darkred;
    }
    .cancelButton {
        height: 40px;
        width: 200px;
        border-radius: 5px;
        border-color: rgb(239, 239, 239);
        cursor: pointer;
        font-size: 16px;
        margin-left: 550px;
    }
</style>